/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, FormControl, InputLabel, Select, MenuItem, FormHelperText, Typography } from '@mui/material';

const BudgetCodesSection = ({
    formik,
    uniqueBranchCodes,
    filteredProjectCodes,
    filteredBudgetLines,
    handleBranchCodeChange,
    handleProjectCodeChange
}) => (
    <>
        {/* Branch Code */}
        <Grid item xs={12} md={4}>
            <FormControl fullWidth error={formik.touched.branchCode && Boolean(formik.errors.branchCode)}>
                <InputLabel>Branch Code</InputLabel>
                <Select
                    name="branchCode"
                    value={formik.values.branchCode}
                    onChange={(e) => {
                        formik.handleChange(e);
                        handleBranchCodeChange(e.target.value, formik.setFieldValue);
                    }}
                    label="Branch Code"
                >
                    {uniqueBranchCodes.map((branch) => (
                        <MenuItem key={branch.id} value={branch.id}>
                            {`${branch.code} - ${branch.name}`}
                        </MenuItem>
                    ))}
                </Select>
                {formik.touched.branchCode && formik.errors.branchCode && (
                    <FormHelperText>{formik.errors.branchCode}</FormHelperText>
                )}
            </FormControl>
        </Grid>

        {/* Project Code */}
        <Grid item xs={12} md={4}>
            <FormControl fullWidth error={formik.touched.projectCode && Boolean(formik.errors.projectCode)}>
                <InputLabel>Project Code</InputLabel>
                <Select
                    name="projectCode"
                    value={formik.values.projectCode}
                    onChange={(e) => {
                        formik.handleChange(e);
                        handleProjectCodeChange(e.target.value, formik.setFieldValue);
                    }}
                    disabled={!formik.values.branchCode}
                    label="Project Code"
                >
                    {filteredProjectCodes.map((project) => (
                        <MenuItem key={project.id} value={project.id}>
                            {`${project.code} - ${project.description}`}
                        </MenuItem>
                    ))}
                </Select>
                {formik.touched.projectCode && formik.errors.projectCode && (
                    <FormHelperText>{formik.errors.projectCode}</FormHelperText>
                )}
            </FormControl>
        </Grid>

        {/* Budget Line */}
        <Grid item xs={12} md={4}>
            <FormControl fullWidth error={formik.touched.budgetLine && Boolean(formik.errors.budgetLine)}>
                <InputLabel>Budget Line</InputLabel>
                <Select
                    name="budgetLine"
                    value={formik.values.budgetLine}
                    onChange={formik.handleChange}
                    disabled={!formik.values.projectCode}
                    label="Budget Line"
                >
                    {filteredBudgetLines.map((line) => (
                        <MenuItem key={line.id} value={line.id}>
                            {`${line.code} - ${line.description}`}
                            {line.currentBalance && (
                                <Typography variant="caption" color="textSecondary" sx={{ ml: 1 }}>
                                    (Balance: ${line.currentBalance.toFixed(2)})
                                </Typography>
                            )}
                        </MenuItem>
                    ))}
                </Select>
                {formik.touched.budgetLine && formik.errors.budgetLine && (
                    <FormHelperText>{formik.errors.budgetLine}</FormHelperText>
                )}
            </FormControl>
        </Grid>
    </>
);

BudgetCodesSection.propTypes = {
    formik: PropTypes.object.isRequired,
    uniqueBranchCodes: PropTypes.array.isRequired,
    filteredProjectCodes: PropTypes.array.isRequired,
    filteredBudgetLines: PropTypes.array.isRequired,
    handleBranchCodeChange: PropTypes.func.isRequired,
    handleProjectCodeChange: PropTypes.func.isRequired
};

export default BudgetCodesSection; 